import { DataTypeOptions, Day } from '@core/constants/data-types.constants';

export function calculateYears(): { key: string; value: number }[] {
  const years: { key: string; value: number }[] = [];
  const yearsLimits = calculateBirthdateYearsLimits();
  for (let i = 0; i <= yearsLimits.max - yearsLimits.min; i++) {
    years.push({
      key: String(yearsLimits.max - i),
      value: yearsLimits.max - i
    });
  }
  return years;
}

export function calculateBirthdateYearsLimits(): { min: number; max: number } {
  const currentYear = new Date().getFullYear();
  return {
    min: currentYear - 75,
    max: currentYear - 18
  };
}

export function calculateGoalYearsLimits(): { min: number; max: number } {
  const currentYear = new Date().getFullYear();
  return {
    min: currentYear + 1,
    max: currentYear + 100
  };
}

export function calculateDaysOfMonth(month: number, year: number): DataTypeOptions<Day> {
  const days: DataTypeOptions<Day> = [];
  const date = new Date(year, month, 0);
  for (let i = 1; i <= date.getDate(); i++) {
    days.push({
      key: i + '',
      value: i
    });
  }
  return days;
}

export function calculateLastDayOfMonth(month: number, year: number): number {
  const date = new Date(year, month, 0);
  return date.getDate();
}
